import React, { Component } from 'react';
import axios from "axios";
import Api from "../../customlib/Api";
import moment from "moment";
import Global from "../../customlib/Global"


import { makeStyles } from '@mui/styles';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton, Box, Typography, CircularProgress} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { MoreVert, Search } from '@mui/icons-material';
import ExportInboundReferral from './ExportInboundReferral';
import DateRangePicker from '../../customlib/DateRangePicker';
import ByReferralMobile from '../ReportMobile/LeadsReportSummary/ByReferralMobile';
import ExportLeadsTiktok from './ExportLeadsTiktok';

class InboundByreferral extends Component {
    state = { 
        contactLeads : [],
        contactLeadsTiktok : [],
        boostPostLeads : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        startDateBoost: moment(new Date()).format("YYYY-MM-DD"),
        endDateboost: moment(new Date()).format("YYYY-MM-DD"),
        startDateTiktok: moment(new Date()).format("YYYY-MM-DD"),
        endDateTiktok: moment(new Date()).format("YYYY-MM-DD"),
        page: 0,
        rowsPerPage: 30,
        value: '0',
        isTeleReport: true,
        isLoading: false,
        isLoadingBoost: false,
        isLoadingTiktok: false
    }
    
    componentDidMount() {
      this.getLeadsByTiktok();
      this.getLeadsByReferral();
      this.getBoostPostLeads();
    }

    getLeadsByReferral = () => {
      console.log("STARTDATE : ",this.state.startDate);
      var userData = Global.get();
      console.log("USERDATA : ", userData);
      console.log("USERDATA", userData);

      var params = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        appProfileId: Global.getAppProfile()._id,
        referralCode: "utm_medium=bio-IG"
      };

      this.setState({contactLeads: [], isLoading: true});

      console.log("PARAMS", params);

      axios
        .post(Api.inobundByReferral(), params, Api.getRequestHeader())
        .then((response) => {
          console.log("CONTACTLEADS : ", response.data);
          console.log("USERDATA : ", "wkwkwk");
          
          var tmpContactLeads = response.data.data;

          this.setState({contactLeads: tmpContactLeads, isLoading: false});
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    };

    getBoostPostLeads = () => {
      console.log("STARTDATE : ",this.state.startDate);
      var userData = Global.get();
      console.log("USERDATA : ", userData);
      console.log("USERDATA", userData);

      var params = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        appProfileId: Global.getAppProfile()._id,
        keyword: "Halo! Bisakah saya mendapatkan info selengkapnya tentang ini?"
      };

      console.log("PARAMS", params);

      this.setState({boostPostLeads: [], isLoadingBoost: true}, () => {
        axios
          .post(Api.boostPostLeads(), params, Api.getRequestHeader())
          .then((response) => {
            console.log("CONTACTLEADS : ", response.data);
            console.log("USERDATA : ", "wkwkwk");
            
            var tmpContactLeads = response.data.data;

            this.setState({boostPostLeads: tmpContactLeads, isLoadingBoost: false});
          })
          .catch((error) => {
            this.setState({isLoadingBoost: false})
            console.error("There was an error!", error);
          });
        });
    };

    getLeadsByTiktok = () => {

      var params = {
        startDate: this.state.startDateTiktok,
        endDate: this.state.endDateTiktok,
        // appProfileId: Global.getAppProfile()._id,
        // referralCode: "utm_medium=bio-IG"
      };

      this.setState({contactLeadsTiktok: [], isLoadingTiktok: true});

      console.log("PARAMS", params);

      axios
        .post(Api.leadByReferralSosmed(), params, Api.getRequestHeaderJsonNew())
        .then((response) => {
          
          var tmpContactLeads = response.data.data;

          this.setState({contactLeadsTiktok: tmpContactLeads, isLoadingTiktok: false});
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    };

    handleStartDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ startDate:  formatStartDate},  () => {this.getLeadsByReferral()});
    };

    handleEndDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ endDate:  formatStartDate}, () => {this.getLeadsByReferral()});
    };

    handleDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDate: startDate, endDate:  endDate}, () => {this.getLeadsByReferral()});
    }

    handleTiktokDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDateTiktok: startDate, endDateTiktok:  endDate}, () => {this.getLeadsByTiktok()});
    }

    handleBoostDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDateBoost: startDate, endDateboost:  endDate}, () => {this.getBoostPostLeads()});
    }

    columns = [
        { id: 'from', label: 'From', minWidth: 170 },
        { id: 'fromName', label: 'Name', minWidth: 100 },
        { id: 'created_at', label: 'Tanggal', minWidth: 100 }
    ];

    columnsBoost = [
        { id: 'fromName', label: 'Nama', minWidth: 170 },
        { id: 'fromName', label: 'Nomor WhatsApp', minWidth: 100 },
        { id: 'label', label: 'Label', minWidth: 100 },
        { id: 'leadType', label: 'Tipe Lead', minWidth: 100 },
        { id: 'status', label: 'Status', minWidth: 100 },
        { id: 'productCategory', label: 'Kategori', minWidth: 100 },
        { id: 'gender', label: 'Gender', minWidth: 100 },
        { id: 'occasion', label: 'Occasion', minWidth: 100 },
        { id: 'groupReason', label: 'Group Alasan', minWidth: 100 },
        { id: 'reason', label: 'Alasan', minWidth: 100 },
        { id: 'cityName', label: 'Kota', minWidth: 100 },
        { id: 'created_at', label: 'Tanggal Lead', minWidth: 100 },
        { id: 'lastMessageReceivedAt', label: 'Chat Terakhir', minWidth: 100 },
        // { id: 'action', label: 'Action', minWidth: 100 },
    ];

    render() { 

      if(this.props.isMobile){
        return (
          <ByReferralMobile 
            {...this.props}
            isLoading={this.state.isLoading}
            contactLeads={this.state.contactLeads}
            getContactLeads={this.getLeadsByReferral}
            handleDateChanged={this.handleDateChanged}
          />
        );
      }

        return ( 
          <Paper elevation={0} style={{padding:"0px"}}>

                <Box>
                  <div className="panel panel-default">
                      <div className="panel-heading">
                          <div className="panel-title">
                              <h1>Leads From Tiktok</h1>
                          </div>
                      </div>
                      <div className="panel-body">
                          <div className="row align-items-center">
                              <div className="col-3">
                                  <strong>Total {this.state.contactLeadsTiktok.length} leads</strong>
                              </div>
                              <div className="col-3">
                                <ExportLeadsTiktok data={this.state.contactLeadsTiktok} />
                              </div>
                              <div className="col-5 text-right" style={{borderRadius: 10, padding: 5}}>
                                <DateRangePicker onDateChanged={this.handleTiktokDateChanged} />
                              </div>
                              <div className="col-1">
                              {
                                    this.state.isLoading === true ? 
                                        (<CircularProgress style={{marginTop: 15}} size={30} color="secondary" />) : 
                                        (<div onClick={() => {this.getLeadsByTiktok()}} className="btn btn-primary" style={{padding: 8}}><Search /></div>)
                                }
                            </div>
                          </div>
                          <br />
                          <Paper className="root">
                              <TableContainer>
                                  <Table aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                          <TableCell
                                                key={"col-campaign"}
                                                align={"left"}
                                                style={{ minWidth: 150 }}
                                            >
                                              Campaign
                                            </TableCell>
                                          <TableCell
                                                key={"col-leadscount"}
                                                align={"left"}
                                                style={{ minWidth: 150 }}
                                            >
                                              Leads
                                            </TableCell>
                                          <TableCell
                                                key={"col-closing"}
                                                align={"center"}
                                                style={{ minWidth: 150 }}
                                            >
                                              Closing
                                            </TableCell>
                                          <TableCell
                                                key={"col-closingrate"}
                                                align={"center"}
                                                style={{ minWidth: 150 }}
                                            >
                                              Closing Rate
                                            </TableCell>
                                          <TableCell
                                                key={"col-revenue"}
                                                align={"left"}
                                                style={{ minWidth: 150 }}
                                            >
                                              Revenue
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.contactLeadsTiktok.map((row) => {
                                        return (
                                            <TableRow>
                                              <TableCell>{row.campaign}</TableCell>
                                              <TableCell align="center">{row.leadsCount}</TableCell>
                                              <TableCell align="center">{row.closing}</TableCell>
                                              <TableCell align='center'>{row.closingRate ? row.closingRate.toFixed(2) : 0}%</TableCell>
                                              <TableCell align="right">{row.orderValue?.toFixed(2)}</TableCell>
                                            </TableRow>
                                        );
                                        })}
                                    </TableBody>
                                  </Table>
                              </TableContainer>
                          </Paper>
                      </div>
                      <div className="panel-footer"></div>
                  </div>
                </Box>

                <Box>
                  <div className="panel panel-default">
                      <div className="panel-heading">
                          <div className="panel-title">
                              <h1>Inbound Referral Instagram</h1>
                          </div>
                      </div>
                      <div className="panel-body">
                          <div className="row align-items-center">
                              <div className="col-3">
                                  <strong>Total {this.state.contactLeads.length} Inbound</strong>
                              </div>
                              <div className="col-3">
                                <ExportInboundReferral data={this.state.contactLeads} />
                              </div>
                              <div className="col-5 text-right" style={{borderRadius: 10, padding: 5}}>
                                <DateRangePicker onDateChanged={this.handleDateChanged} />
                              </div>
                              <div className="col-1">
                              {
                                    this.state.isLoading === true ? 
                                        (<CircularProgress style={{marginTop: 15}} size={30} color="secondary" />) : 
                                        (<div onClick={() => {this.getLeadsByReferral()}} className="btn btn-primary" style={{padding: 8}}><Search /></div>)
                                }
                            </div>
                          </div>
                          <br />
                          <Paper className="root">
                              <TableContainer>
                                  <Table aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                        {this.columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                            {column.label}
                                            </TableCell>
                                        ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.contactLeads.map((row) => {
                                        return (
                                            <TableRow>
                                              <TableCell>{row.from}</TableCell>
                                              <TableCell>{row.fromName}</TableCell>
                                              <TableCell>{Global.formatDateTimeToStrDateTime24(row.created_at)}</TableCell>
                                            </TableRow>
                                        );
                                        })}
                                    </TableBody>
                                  </Table>
                              </TableContainer>
                          </Paper>
                      </div>
                      <div className="panel-footer"></div>
                  </div>
                </Box>

                <Box sx={{mt: "30px"}}>
                  <div className="panel panel-default">
                      <div className="panel-heading">
                          <div className="panel-title">
                              <h1>Boost Post Leads</h1>
                          </div>
                      </div>
                      <div className="panel-body">
                          <div className="row align-items-center">
                              <div className="col-3">
                                  <strong>Total {this.state.boostPostLeads.length} Inbound</strong>
                              </div>
                              <div className="col-3">
                                <ExportInboundReferral data={this.state.boostPostLeads} />
                              </div>
                              <div className="col-5 text-right" style={{borderRadius: 10, padding: 5}}>
                                <DateRangePicker onDateChanged={this.handleBoostDateChanged} />
                              </div>
                              <div className="col-1">
                              {
                                    this.state.isLoadingBoost === true ? 
                                        (<CircularProgress style={{marginTop: 15}} size={30} color="secondary" />) : 
                                        (<div onClick={() => {this.getBoostPostLeads()}} className="btn btn-primary" style={{padding: 8}}><Search /></div>)
                                }
                            </div>
                          </div>
                          <br />
                          <Paper className="root">
                              <TableContainer>
                                  <Table aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                        {this.columnsBoost.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                            {column.label}
                                            </TableCell>
                                        ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.boostPostLeads.map((row) => {
                                        return (
                                            <TableRow>
                                              <TableCell>{row.fromName}</TableCell>
                                              <TableCell>{row.from}</TableCell>
                                              <TableCell>{row.label}</TableCell>
                                              <TableCell>{row.tipeLead}</TableCell>
                                              <TableCell>{row.status}</TableCell>
                                              <TableCell>{row.productCategory}</TableCell>
                                              <TableCell>{row.gender}</TableCell>
                                              <TableCell>{row.occasion}</TableCell>
                                              <TableCell>{row.groupReason}</TableCell>
                                              <TableCell>{row.reason}</TableCell>
                                              <TableCell>{row.cityName}</TableCell>
                                              <TableCell>{Global.formatDateTimeToStrDateTime24(row.created_at)}</TableCell>
                                              <TableCell>{Global.formatDateTimeToStrDateTime24(row.lastMessageReceivedAt)}</TableCell>
                                              {/* <TableCell><MoreVert /></TableCell> */}
                                            </TableRow>
                                        );
                                        })}
                                    </TableBody>
                                  </Table>
                              </TableContainer>
                          </Paper>
                      </div>
                      <div className="panel-footer"></div>
                  </div>
                </Box>
              </Paper>
         );
    }
}
 
export default InboundByreferral;